import { render, staticRenderFns } from "./MapBuildingLevelSelector.vue?vue&type=template&id=5524f994&scoped=true"
import script from "./MapBuildingLevelSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./MapBuildingLevelSelector.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MapBuildingLevelSelector.vue?vue&type=style&index=0&id=5524f994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5524f994",
  null
  
)

export default component.exports